<template>
  <div v-if="loading || !dataExists" class="rbz-loader" :style="{ height: height }">
    <template v-if="loading">
      <div
        class="spinner is-loading"
        :style="`--spinner-size:${loaderSize}; --spinner-width:8px`"
      ></div>
    </template>
    <template v-else>
      <template v-if="$slots.noDataOverride">
        <slot name="noDataOverride" />
      </template>
      <template v-else>
        {{ noDataMessageWithDefaults }}
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import _ from 'lodash';

const { t } = useI18n();

interface RbzLoaderProps {
  loading: boolean;
  dataExists: boolean;
  noDataMessage?: string;
  height?: string;
  loaderSize?: string;
}

const props = withDefaults(defineProps<RbzLoaderProps>(), {
  height: '80px',
  noDataMessage: null,
  loaderSize: '80px',
});

const noDataMessageWithDefaults = computed(() => {
  if (props.noDataMessage) {
    return props.noDataMessage;
  } else {
    return t('common.noDataMessage');
  }
});
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '../../assets/styles/colors' as colors;

.rbz-loader {
  align-items: center;
  background: map.get(colors.$colors, 'white');
  display: flex;
  font-size: 14px;
  justify-content: center;
  left: 0;
  line-height: 18px;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
}
</style>
